export enum DepositDialogState {
  Intro = 'intro',
  Informations = 'informations',
}
